<mat-icon *ngIf="data.icon" [svgIcon]="data.icon"></mat-icon>
<span>
  {{ data.message }}
</span>
